export enum MICROGRID_STATUS {
  NONE = 'NONE',
  DEVELOPED = 'DEVELOPED',
  DEVELOPED_OPERATING = 'DEVELOPED_OPERATING'
}
